import React from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'

import FolderTitleBar from './FolderTitleBar'
import * as Content from '../reducers/Content'
import { selectedFolder } from '../selectors'
import Permissions from './Permissions'

const Head = (props) => (
  <div className="topBarHead">
    <div className="topBarHeadContainer">
      <div className="topBarHeadInnerContainer">
        <img
          className="topBarLogo"
          src="/boards-black.svg"
          alt=""
          draggable="false"
        />
        {props.environment && (
          <span className="topBarEnvironment">{props.environment}</span>
        )}
      </div>
    </div>
  </div>
)

class TopBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showsPermissions: false,
    }
  }

  setShowsPermissions = (showsPermissions) => {
    this.setState({ showsPermissions })
  }

  toggleShowsPermissions = () => {
    this.setShowsPermissions(!this.state.showsPermissions)
  }

  onClickShare = () => {
    this.toggleShowsPermissions()
  }

  onPermissionsClickOutside = (className) => {
    if (className.indexOf('folderTitleShareButton') < 0) {
      this.setShowsPermissions(false)
    }
  }

  onPermissionsDone = () => {
    this.setShowsPermissions(false)
  }

  render() {
    const { contentId, folder, isRoot, isViewOnly, firebase } = this.props
    const environment = window.usingDevelopmentServer ? '/DEV' : undefined
    return (
      <div className="topBar">
        <Head environment={environment} />
        {folder && (
          <FolderTitleBar
            contentId={contentId}
            folder={folder}
            isRoot={isRoot}
            isViewOnly={isViewOnly}
            onClickShare={this.onClickShare}
          />
        )}
        <div className="topBarDelimiter" />
        {this.state.showsPermissions && (
          <Permissions
            firebase={firebase}
            onClickOutside={this.onPermissionsClickOutside}
            onDone={this.onPermissionsDone}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const { content } = ownProps
  const folder = selectedFolder(state)
  const parent = folder ? Content.parentOfId(content, folder.id) : null
  const isRoot = parent === null
  return {
    isRoot,
    folder,
  }
}

const ConnectedTopBar = connect(mapStateToProps, actions)(TopBar)
export default ConnectedTopBar
